import { Loader2, Trash2 } from "lucide-react";

function fmtDate(iso) {
  return new Date(iso).toLocaleDateString(undefined, {
    month: "short",
    day: "numeric",
  });
}

function pnlClass(profit) {
  if (profit > 0) return "neon-text";
  if (profit < 0) return "text-red-400";
  return "text-zinc-500";
}

function resultBadgeClass(result) {
  if (result === "win") return "border-[#00D4FF] text-[#00D4FF]";
  if (result === "loss") return "border-red-400 text-red-400";
  return "border-zinc-600 text-zinc-400";
}

function BetRow({ bet, onDelete }) {
  return (
    <tr className="border-t border-zinc-800" data-testid={`bet-row-${bet.id}`}>
      <td className="px-3 py-3 text-zinc-500">{fmtDate(bet.created_at)}</td>
      <td className="px-3 py-3 text-zinc-300 uppercase">{bet.sport}</td>
      <td className="px-3 py-3 text-white">
        {bet.pick}
        <span className="text-zinc-600"> · step {bet.step}</span>
      </td>
      <td className="px-3 py-3 text-right text-zinc-300">${bet.stake}</td>
      <td className={`px-3 py-3 text-right ${pnlClass(bet.profit)}`}>
        {bet.profit >= 0 ? "+" : ""}${bet.profit}
      </td>
      <td className="px-3 py-3">
        <span
          className={`px-2 py-1 uppercase text-[10px] tracking-wider border ${resultBadgeClass(
            bet.result
          )}`}
        >
          {bet.result}
        </span>
      </td>
      <td className="px-3 py-3 text-right text-zinc-300">${bet.bankroll_after}</td>
      <td className="px-3 py-3 text-right">
        <button
          onClick={() => onDelete(bet.id)}
          data-testid={`bet-delete-${bet.id}`}
          className="text-zinc-500 hover:text-red-400"
        >
          <Trash2 size={14} strokeWidth={1.5} />
        </button>
      </td>
    </tr>
  );
}

export default function BetTable({ bets, loading, onDelete }) {
  if (loading) {
    return (
      <div className="flex items-center gap-2 text-zinc-400">
        <Loader2 size={16} className="animate-spin text-[#00D4FF]" /> Loading…
      </div>
    );
  }
  if (bets.length === 0) {
    return (
      <div className="border border-dashed border-zinc-800 p-12 text-center">
        <div className="font-display text-xl text-zinc-400">No bets yet</div>
        <p className="text-sm text-zinc-500 mt-2">
          Log your first bet using the form on the left.
        </p>
      </div>
    );
  }
  return (
    <div className="border border-zinc-800 overflow-hidden">
      <table className="w-full mono text-sm" data-testid="bets-table">
        <thead className="bg-zinc-900">
          <tr className="text-left">
            <th className="px-3 py-3 overline">WHEN</th>
            <th className="px-3 py-3 overline">SPORT</th>
            <th className="px-3 py-3 overline">PICK</th>
            <th className="px-3 py-3 overline text-right">STAKE</th>
            <th className="px-3 py-3 overline text-right">P/L</th>
            <th className="px-3 py-3 overline">RESULT</th>
            <th className="px-3 py-3 overline text-right">BR</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {bets.map((b) => (
            <BetRow key={b.id} bet={b} onDelete={onDelete} />
          ))}
        </tbody>
      </table>
    </div>
  );
}
